import createReducer from '../../../helpers/createReducer';
import { fetchSignature } from '../../sagas/signature/routines';
import { createFetchOneHandler } from '../../../helpers/reducerRoutineCrudHandler';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null
};

export default createReducer(initialState, {
  ...createFetchOneHandler(fetchSignature)
});
